"use strict";

angular.module("portal.lookup").controller("Lookup", [
    "$scope",
    "$state",
    "$rootScope",
    "Enterprise",
    "EnterprisePublicLookup",
    function (
        $scope,
        $state,
        $rootScope,
        Enterprise,
        EnterprisePublicLookup
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.promises = [];
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID
        };
        $scope.lookup_options = []; // types of lookup
        $scope.lookup_object = { lookup_option: "users" }; // input values for lookup
        $scope.license_label = "License";
        $scope.filterFound = false;
        $scope.messages = ["Please enter a value into one of the filter fields to search."];
        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
            $scope.loading = false;
        } else {
            if ($rootScope.userAccount !== null) {
                Enterprise.get($scope.parameters).then(function (result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            } else {
                $scope.parameters.isPortal = true;
                Enterprise.getLess($scope.parameters).then(function (result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            }
        }

        //recaptcha vars
        $scope.lookup_object.recaptcha_passed = $scope.enterprise.recaptcha_enabled ? false : true; //to gatekeep intended function, make true if recaptcha is off
        $scope.recaptchaMessage = ($scope.enterprise.recaptcha_site_key_v3 == null && $scope.enterprise.recaptcha_enabled) ? "There was an issue loading recaptcha, please try again or contact system administrator." : ""; //message to display

        // Get the entity labels
        $scope.userLabel = $scope.enterprise.userLabels["USER"];
        $scope.serviceLabel = $scope.enterprise.serviceLabels["SERVICE"];
        $scope.vehicleLabel = $scope.enterprise.vehicleLabels["VEHICLE"];

        // Get the specific lookup page(s) that are turned on, so we only do that/those kind(s) of lookup
        var userLookupPage = $rootScope.portal_pages["portal.menus.userlookup"];
        if (
            userLookupPage != null &&
            userLookupPage.visible &&
            userLookupPage.show_menu
        ) {
            $scope.lookup_options.push({ id: "users", name: $scope.userLabel });
        }
        var serviceLookupPage = $rootScope.portal_pages["portal.menus.servicelookup"];
        if (
            serviceLookupPage != null &&
            serviceLookupPage.visible &&
            serviceLookupPage.show_menu
        ) {
            $scope.lookup_options.push({
                id: "services",
                name: $scope.serviceLabel
            });
        }
        var vehicleLookupPage = $rootScope.portal_pages["portal.menus.vehiclelookup"];
        if (
            vehicleLookupPage != null &&
            vehicleLookupPage.visible &&
            vehicleLookupPage.show_menu
        ) {
            $scope.lookup_options.push({ id: "vehicles", name: $scope.vehicleLabel });
        }
        $scope.lookup_object.lookup_option = $scope.lookup_options[0].id;

        // Get the lookup filters
        EnterprisePublicLookup.get({
            enterpriseID: $rootScope.enterpriseID,
            code: "filter"
        }).then(function (result) {
            if (result != null) {
                result.forEach(function (filter) {
                    if (filter.alias == "application_level_id" || filter.alias == "certification_level_id") {
                        filter.selectShow = "combined_name";
                    } else {
                        filter.selectShow = "name";
                    }
                });
                $scope.filters = result;
                $scope.filtersAlias = [];
                result.forEach(function (filter) {
                    $scope.filtersAlias.push(filter.alias);
                });
                $scope.userFilters = result.filter(function (col) {
                    return col.entity == "User";
                });
                $scope.serviceFilters = result.filter(function (col) {
                    return col.entity == "Services";
                });
                $scope.vehicleFilters = result.filter(function (col) {
                    return col.entity == "Vehicles";
                });
            }
        });

        // Get the lookup search columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "search"
        }).then(function (result) {
            if (result != null) {
                $scope.search_columns = result;
            }
        });

        function submitSwitch() {
            switch ($scope.lookup_object.lookup_option) {
                case "users":
                    $state.go("portal.menus.userlookup", {
                        lookup_object: $scope.lookup_object
                    });
                    break;
                case "services":
                    $state.go("portal.menus.servicelookup", {
                        lookup_object: $scope.lookup_object
                    });
                    break;
                case "vehicles":
                    if ($scope.lookup_object.recaptcha_passed) {
                        var params = [];
                        if ($scope.lookup_object.call_sign) params.push('callSign=' + encodeURIComponent($scope.lookup_object.call_sign));
                        if ($scope.lookup_object.dmv_number) params.push('dmvNumber=' + encodeURIComponent($scope.lookup_object.dmv_number));
                        if ($scope.lookup_object.location_address) params.push('locationAddress=' + encodeURIComponent($scope.lookup_object.location_address));
                        if ($scope.lookup_object.location_name) params.push('locationName=' + encodeURIComponent($scope.lookup_object.location_name));
                        if ($scope.lookup_object.make) params.push('make=' + encodeURIComponent($scope.lookup_object.make));
                        if ($scope.lookup_object.model) params.push('model=' + encodeURIComponent($scope.lookup_object.model));
                        if ($scope.lookup_object.serial_number) params.push('serialNumber=' + encodeURIComponent($scope.lookup_object.serial_number));
                        if ($scope.lookup_object.vehicle_type) params.push('vehicleType=' + encodeURIComponent($scope.lookup_object.vehicle_type));
                        if ($scope.lookup_object.vin_number) params.push('vehicleType=' + encodeURIComponent($scope.lookup_object.vin_number));
                        if ($scope.lookup_object.year) params.push('year=' + encodeURIComponent($scope.lookup_object.year));

                        var queryString = params.length > 0 ? '?' + params.join('&') : '';
                        window.location.href = $state.href("portal.menus.vehiclelookup") + queryString;
                    }
                    break;
                default:
                    break;
            }
            $scope.looking_up = true;
        };

        $scope.submitSwitch = submitSwitch;

        $scope.search = function () {
            if ($scope.enterprise.recaptcha_enabled) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    $scope.loading = true;
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'publicLookup' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("publicLookup", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.lookup_object.recaptcha_passed = response.success;
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.loading = false;
                                } else {
                                    $scope.lookup_object.recaptcha_passed = response.success;
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.lookup_object.recaptcha_passed == true) {
                                    $scope.submitSwitch(); //continue 
                                } else {
                                    $scope.$apply(); //update dom so error message displays
                                };
                            })
                        } catch(error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.loading = false;
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.submitSwitch();
            };
        };

        // Ensure there is a filter with a value in the lookup
        $scope.$watch("lookup_object", function () {
            if ($scope.filtersAlias && $scope.filtersAlias.length > 0) {
                $scope.filterFound = $scope.filtersAlias.some(function (name) {
                    return $scope.lookup_object.hasOwnProperty(name) && $scope.lookup_object[name] && $scope.lookup_object[name] != '';
                });
            }
        }, true);
    }
]);